<div id="chart" class="w-full" *ngIf="chartOptions.series">
  <apx-chart
    [series]="chartOptions.series"
    [chart]="chartOptions.chart"
    [xaxis]="chartOptions.xaxis"
    [dataLabels]="chartOptions.dataLabels"
    [grid]="chartOptions.grid"
    [stroke]="chartOptions.stroke"
    [title]="chartOptions.title"
    [tooltip]="chartOptions.tooltip"
  ></apx-chart>
</div>
